import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';

/**
 * Empty Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Title of empty Component
     */
    @Prop() title!: string;

    /**
     * Text of empty component
     */
    @Prop() text!: string;

    /**
     * Background Image
     */
    @Prop() src!: string;

    /**
     * hide background image
     */
    @Prop({ type: Boolean }) noImage!: boolean;

    /**
     * Change image and content position
     */
    @Prop({ type: Boolean }) reverse!: boolean;

    /**
     * hide title
     */
    @Prop({ type: Boolean }) noTitle!: boolean;
}

export default Props;
